import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import Exercise from '../Exercise';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExerciseIcon from '@material-ui/icons/School';
import CasinoIcon from '@material-ui/icons/Casino';
import CourseListProgress from './CourseListProgress';
import PartList from './PartList';
import { addSectionStats, setCurrentSectionId, setCourseStats } from '../../redux/actions';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '&>div': {
      marginBottom: '10px',
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
    color: theme.palette.primary.main,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    '& svg': {
      verticalAlign: 'middle',
      marginRight: 20,
      color: theme.palette.primary.dark,
    },
  },
  details: {
    padding: 0,
  },
}));

function CourseList(props) {
  const classes = useStyles();
  const params = useParams();
  const [sections, setSections] = useState([]);
  const testing = props.config.main.testing;
  const listRef = useRef(null);
  const url = `/kurs/${params.course}/${params.tab}/`;

  useEffect(() => {
    const { courseSections } = props;
    setSections(courseSections);
    if (courseSections.length > 0) {
      let sectionsTotal = courseSections.length;
      let percentSum = 0;
      courseSections.forEach(section => {
        percentSum += section.completedPercent;
      });
      const passedPercent = Math.round(percentSum / sectionsTotal);
      props.setCourseStats(passedPercent);
    }
    // eslint-disable-next-line
  }, [props.courseSections]);

  return (
    <div className={classes.root}>
      {sections.map(section => {
        const { title, completedPercent, id, game, slug, accessible } = section;
        const icon = game ? <CasinoIcon /> : <ExerciseIcon />;
        const expanded = params.unit === slug;

        return (
          <Accordion
            key={section.id}
            expanded={expanded}
            disabled={!accessible && !testing}
            ref={expanded ? listRef : null}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} component={Link} to={url + slug}>
              <div className={classes.heading}>
                <div>{icon}{title}</div>
                <CourseListProgress progress={completedPercent} />
              </div>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              {expanded && <PartList
                id={id}
                game={game}
                title={title}
                listRef={listRef}
              />}
            </AccordionDetails>
          </Accordion>
        );
      })}
      {params.exercise && <Exercise />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    courseSections: state.courseSections,
    config: state.config,
    userState: state.userState,
    course: state.course,
  };
}

export default connect(mapStateToProps, {
  addSectionStats,
  setCurrentSectionId,
  setCourseStats,
})(CourseList);
